if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/sw.js', {
    type: 'module', // обязательно: воркер использует ES-импорт
    scope: '/',      // корневой scope, чтобы fallback работал на всём домене
  });
}
